import * as React from 'react'
import Autocomplete, {
  AutocompleteRenderGetTagProps,
} from '@mui/material/Autocomplete'
import { ChipProps } from '@mui/material/Chip'
import Checkbox from '@mui/material/Checkbox'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import ClearIcon from '@mui/icons-material/Clear'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import TextField from '@mui/material/TextField'
import { TextFieldProps } from './TextField'
import { DropDownOptions } from 'types/common'
import { Tooltip } from 'components/ui'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export interface IMultiSelectProps
  extends Omit<TextFieldProps, 'value' | 'onChange'> {
  options?: DropDownOptions[]
  name?: string
  value?: DropDownOptions[] | string[] | string
  hightLightColor?: string
  freeSolo?: boolean
  placeholder?: string
  readOnlyInput?: boolean
  chipProps?: ChipProps
  disablePortal?: boolean
  multiple?: boolean
  disableCloseOnSelect?: boolean
  disableClearable?: boolean
  openOnFocus?: boolean
  inputRef?: any
  tooltipTitle?: string
  renderTags?: (
    value: any[],
    getTagProps: AutocompleteRenderGetTagProps
  ) => React.ReactNode
  onOpen?: (e: React.SyntheticEvent<Element, Event>) => void
  onClose?: (e: React.SyntheticEvent<Element, Event>) => void
  onInputChange?: (e: React.SyntheticEvent<Element, Event>, val: string) => void
  onChange?: (e: React.SyntheticEvent<Element, Event>, val: any) => void
  setValue?: (name: string, value: any) => void
  txtInputId?: string
}

const MultiSelectField: React.FunctionComponent<IMultiSelectProps> = (
  props
) => {
  const {
    txtInputId,
    label,
    options,
    onInputChange,
    onChange,
    renderTags,
    value,
    error,
    helperText,
    disabled,
    freeSolo = false,
    className,
    placeholder,
    disablePortal = false,
    multiple = true,
    readOnlyInput = false,
    disableCloseOnSelect = false,
    disableClearable = false,
    openOnFocus = false,
    chipProps,
    inputRef,
    tooltipTitle = 'clear',
    onOpen,
    onClose,
    onBlur,
  } = props

  return (
    <Autocomplete
      id={txtInputId}
      options={options ? options : []}
      value={value}
      disabled={disabled}
      freeSolo={freeSolo}
      ChipProps={chipProps}
      renderTags={renderTags}
      clearIcon={
        <Tooltip title={tooltipTitle}>
          <ClearIcon fontSize="small" />
        </Tooltip>
      }
      onOpen={onOpen}
      onClose={onClose}
      onInputChange={(event, newInputValue) => {
        onInputChange && onInputChange(event, newInputValue)
      }}
      onChange={(e, val) => {
        onChange && onChange(e, val)
      }}
      renderOption={
        multiple
          ? (props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.label}
              </li>
            )
          : undefined
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          label={label}
          error={error}
          helperText={helperText}
          disabled={disabled}
          className={className}
          onBlur={onBlur}
          inputRef={inputRef}
        />
      )}
      onKeyDown={(e) => readOnlyInput && e.preventDefault()}
      multiple={multiple}
      disablePortal={disablePortal}
      disableCloseOnSelect={disableCloseOnSelect}
      disableClearable={disableClearable}
      openOnFocus={openOnFocus}
      disableListWrap
    />
  )
}

export default MultiSelectField
